module.exports = __webpack_public_path__ + "static/media/dotbgtexture.0d6a3703.png";